var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.8334 3.75V7.41667C13.8334 7.65978 13.93 7.89294 14.1019 8.06485C14.2738 8.23676 14.5069 8.33333 14.75 8.33333H18.4167M13.8334 3.75H7.41671C6.93048 3.75 6.46416 3.94315 6.12034 4.28697C5.77653 4.63079 5.58337 5.0971 5.58337 5.58333V12.9167M13.8334 3.75L18.4167 8.33333M18.4167 8.33333V18.4167C18.4167 18.9029 18.2236 19.3692 17.8797 19.713C17.5359 20.0568 17.0696 20.25 16.5834 20.25H11.5417M2.83337 18.4167H9.25004M9.25004 18.4167L6.50004 15.6667M9.25004 18.4167L6.50004 21.1667",
    stroke: "#222222",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImport);
export default __webpack_public_path__ + "static/media/import.9b37935836a066e4fa5e9143f4a106f5.svg";
export { ForwardRef as ReactComponent };